import React, { useEffect, useRef, useState } from 'react';
import { observer, useLocalObservable } from 'mobx-react-lite';
import client, { SIZE_MODEL_BIG, SIZE_MODEL_SMALL } from '@/store/client';
import { SVGPureIcon } from '@/ui';
import Conf from '@/common/conf';
import wsStore from '../chat-ws/store';
import { Tooltip, Modal } from 'antd';
import globalStore from '@/store/global';
import "./index.scss"

const ClientHeader = observer((props) => {
  if(!client.isClient){
    return;
  }

  const [showAskModal, setShowAskModal] = useState(false)
  const [showSizeChangeIcon, setShowSizeChangeIcon] = useState(true) // 低版本默认展示
  const shortCutModalRef = useRef(null)

  // 禁止冒泡
  const stopPropagation = (event) => {
    event.stopPropagation();
  }

  const onClose = () => {
    if(client.versionLt("14.0.0.1171") || client.sizeModel == SIZE_MODEL_SMALL) {
      client.run("CloseWnd");
      return
    }

    client.run("IsNeedShowShortcutDlg", (IsNeedShowShortcutDlg) => {
      if(!IsNeedShowShortcutDlg) {
        client.run("CloseWnd");
        return
      }
      setShowAskModal(true)
      client.run("SetShortcutDlgShowTime")
    }, Number(globalStore?.cloudConfig?.assistantDsShortcutDlgDuration?.duration || "7"));
  }

  const handleOk = () => {
    setShowAskModal(false)
    client.run("CreateShortcut")
    client.run("CloseWnd");
  }

  const handleCancel = () => {
    setShowAskModal(false)
    client.run("CloseWnd");
  }
  const createShortcut = () => {
    client.run("IsNeedShowShortcutDlg", (IsNeedShowShortcutDlg) => {
      if(IsNeedShowShortcutDlg == 1) {
        client.run("CreateShortcut")
      }
    }, Number(globalStore?.cloudConfig?.assistantDsShortcutDlgDuration?.duration || "7"));
  }

  useEffect(() => {
    if(client.versionLt("14.0.0.1171")) return
    client.run("IsFirstSetMode", (IsFirstSetMode) => {
      if(IsFirstSetMode) {
        client.changeSize(SIZE_MODEL_BIG)
      }
    })
  }, [client.version])

  useEffect(() => {
    if(client.versionLt("14.0.0.1181")) return
    client.run('IsFirstRun',IsFirstRun=>{
      if(IsFirstRun == 1) {
        createShortcut()
      }
    })
    setShowSizeChangeIcon(false) // >=14.0.0.1171不展示
  }, [client.version])

  return (
    <>
      <div
        className={`h-48px w-full flex justify-between border-bottom-1px border-black-10 flex-shrink-0 ${client.canDrag ? 'cursor-move' : ''}`}
        onMouseDown={ () => { client.run("MoveStart") } }
        onMouseUp={ () => { client.run("MoveEnd") } }
        >
        <div
          className={`flex items-center h-full ${client.sizeModel == SIZE_MODEL_BIG ? 'opacity-0 pointer-events-none' : ''}`}>
          <img src={globalStore.appIcon} className="size-24px ml-16px mr-10px" />
          <div className='text-primary text-17px'>{Conf.appName}</div>
        </div>
        <div className='flex self-start pt-6px pr-4px'>
        {!showSizeChangeIcon ? <Tooltip title="创建快捷方式" placement="bottom" autoAdjustOverflow={false}>
            <div 
              className="w-18px h-18px cursor-pointer mr-12px"
              onMouseDown={stopPropagation}
              onMouseUp={stopPropagation}
              >
              <SVGPureIcon 
                name="client_create_shortcut" 
                // iconClass="text-primary-opacity text-opacity-60" 
                size={18} 
                onClick={()=>{client.run("CreateShortcut")}} 
                />
            </div>
          </Tooltip>: null}
          {showSizeChangeIcon ? <Tooltip title={client.sizeModel == SIZE_MODEL_SMALL ? "居中" : "收起"}>
            {
              client.sizeModel == SIZE_MODEL_SMALL
              ? (
                <div 
                  onMouseDown={stopPropagation}
                  onMouseUp={stopPropagation}
                  className="w-18px h-18px cursor-pointer mr-16px">
                  <SVGPureIcon
                    name="client_resize_big" 
                    iconClass="text-primary-opacity text-opacity-60" 
                    size={18} 
                    onClick={
                      () => {
                        // client.changeSize(SIZE_MODEL_BIG);
                        // 切大窗，要求登录
                        // wsStore.doWhenLogin(() => {
                          client.changeSize(SIZE_MODEL_BIG);
                        // });
                      }
                    } 
                    />
                </div>
              )
              : (
                <div 
                  onMouseDown={stopPropagation}
                  onMouseUp={stopPropagation}
                  className="w-18px h-18px cursor-pointer mr-16px">
                  <SVGPureIcon 
                    name="client_resize_small" 
                    iconClass="text-primary-opacity text-opacity-60" 
                    size={18} 
                    onClick={ () => { client.changeSize(SIZE_MODEL_SMALL) } } 
                    />
                </div>
              )
            }
          </Tooltip>:null}
          <Tooltip title="最小化">
            <div 
              onMouseDown={stopPropagation}
              onMouseUp={stopPropagation}
              className="w-18px h-18px cursor-pointer mr-16px">
              <SVGPureIcon 
                name="client_mini" 
                iconClass="text-primary-opacity text-opacity-60" 
                size={18} 
                onClick={ () => { client.run("MiniWnd") } } 
                />
            </div>
          </Tooltip>
          <Tooltip title={client.isFullscreen ? "还原" : "最大化"}>
            {
              client.isFullscreen
              ? (
                <div 
                  onMouseDown={stopPropagation}
                  onMouseUp={stopPropagation}
                  className="w-18px h-18px cursor-pointer mr-16px">
                  <SVGPureIcon 
                    name="client_restore" 
                    iconClass="text-primary-opacity text-opacity-60" 
                    size={18} 
                    onClick={ () => { client.setFullscreen(false) } } 
                    />
                </div>
              )
              : (
                <div 
                  onMouseDown={stopPropagation}
                  onMouseUp={stopPropagation}
                  className="w-18px h-18px cursor-pointer mr-16px">
                  <SVGPureIcon 
                    name="client_max" 
                    iconClass="text-primary-opacity text-opacity-60" 
                    size={18} 
                    onClick={ () => { client.setFullscreen(true) } } 
                    />
                </div>
              )
            }
          </Tooltip>
          <Tooltip title="关闭" placement="bottomRight" autoAdjustOverflow={false}>
            <div 
              className="w-18px h-18px cursor-pointer mr-12px"
              onMouseDown={stopPropagation}
              onMouseUp={stopPropagation}
              >
              <SVGPureIcon 
                name="client_close" 
                iconClass="text-primary-opacity text-opacity-60" 
                size={18} 
                onClick={onClose} 
                />
            </div>
          </Tooltip>
        </div>
      </div>
      <div className="w-0 h-0 ds-shortcut-modal" ref={shortCutModalRef}>
        <Modal 
          title="" 
          getContainer={() => shortCutModalRef?.current}
          open={showAskModal} 
          maskClosable={false}
          closable={false}
          footer={null}
        >
          <img 
            src="https://p2.ssl.qhimg.com/t110b9a9301511385e520ffcb1a.png" 
            className="w-[18px] h-[18px] absolute cursor-pointer top-[16px] right-[16px]"
            onClick={() => {
              setShowAskModal(false)
            }}
          />
          <div className="mt-[18px] h-[70px] flex items-center">
            <img 
              src="https://p5.ssl.qhimg.com/t110b9a9301925ec8b0f7480272.png" 
              className="w-[70px] h-[70px] mr-[16px]"
            />
            <div className="w-0 flex-grow h-[51px]">
              <div className="font-bold text-[rgba(0,0,0,0.8)] leading-[25px] text-[18px] line-clamp-1">
                创建纳米AI快捷方式，体验正版deepseek
              </div>
              <div className="text-[13px] text-[rgba(0,0,0,0.5)] leading-[18px] mt-[8px]">
                好用不卡机，免费体验
              </div>
            </div>
          </div>
          <div className="mt-[32px] h-[36px] flex items-center justify-end">
            <div className="h-[36px] flex items-center">
              <div 
                className="text-[rgba(0,0,0,0.5)] font-bold text-[13px] leading-[18px] mr-[32px] cursor-pointer"
                onClick={handleCancel}
              >忽略</div>
              <div
                className="w-[92px] h-[36px] rounded-[8px] bg-[#0058FF] text-[#ffffff] font-bold text-[13px] leading-[36px] text-center cursor-pointer"
                onClick={handleOk}
              >立即创建</div>
            </div>
          </div>
        </Modal>
      </div>
    </>
  )
});
export default ClientHeader;